// extracted by mini-css-extract-plugin
export default {"footer":"responsive-styles_footer__Lt3P6","innerFooter":"responsive-styles_innerFooter__Xi7IW","terms":"responsive-styles_terms__ksw6o"};